<h2 mat-dialog-title>Configure access to allow incoming emails</h2>

<mat-dialog-content [formGroup]="configForm" *ngIf="!isFetchingConfig">
    <mat-card class="allow-all">
        <mat-slide-toggle
            formControlName="all"
            color="primary"
            style="margin: 0.5em"
        >
            Allow any incoming emails
        </mat-slide-toggle>
    </mat-card>
    <div
        class="email-row"
        *ngFor="let ctrl of emailDomainsArray.controls; let i = index"
    >
        <mat-form-field appearance="outline" class="email-field">
            <input
                matInput
                [formControl]="ctrl"
                placeholder="Enter domain or email"
                [disabled]="configForm.get('all')?.value"
            />
            <mat-error *ngIf="ctrl.errors?.invalid">
                Invalid email or domain!
            </mat-error>
        </mat-form-field>

        <button
            mat-icon-button
            color="warn"
            (click)="removeField(i)"
            *ngIf="
                emailDomainsArray.length > 1 && !configForm.get('all')?.value
            "
            class="remove-icon"
        >
            <mat-icon>remove_circle</mat-icon>
        </button>
    </div>

    <button
        mat-stroked-button
        color="primary"
        (click)="addField()"
        [disabled]="
            emailDomainsArray.length >= maxInputs ||
            configForm.get('all')?.value
        "
    >
        <mat-icon>add</mat-icon>
        Add More
    </button>
</mat-dialog-content>

<div
    *ngIf="isFetchingConfig"
    style="display: flex; justify-content: center; margin: 2em 2em"
>
    <mat-spinner></mat-spinner>
</div>

<mat-dialog-actions align="end">
    <button mat-button (click)="close()">Cancel</button>
    <button
        mat-flat-button
        color="primary"
        [disabled]="spinner || !configForm.valid"
        (click)="submitConfig()"
    >
        <mat-spinner *ngIf="spinner" diameter="20"></mat-spinner>
        <span *ngIf="!spinner">Save</span>
    </button>
</mat-dialog-actions>
